import { Injectable } from '@angular/core';
import {AngularFirestore} from "@angular/fire/firestore";

@Injectable({
  providedIn: 'root'
})
export class ChangelogService {

  constructor(
    public afs: AngularFirestore,
  ) { }

  addNewChangelog(data) {
    return this.afs.doc(`changelogEsenseLive/${data.appVersion}`).set(data);
  }
  getChangelogs() {
    return this.afs.collection(`changelogEsenseLive/`).valueChanges();
  }
  getCurrentVersionChangelog(appVersion) {
    return this.afs.collection('changelogEsenseLive', ref => ref.where('appVersion', '==', appVersion)).valueChanges();
  }
}
